import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getReportPresets = ({ reportContentId }) =>
  call(websocketFetch, 'get_report_presets', {
    report_content_id: reportContentId,
  });
